// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Messages__container-f38653 {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  --system-bubble-background: var(--pattern-accent-base);
  --system-bubble-color: var(--pattern-accent);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Messages.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,sDAAA;EACA,4CAAA;AAAF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n\n  --system-bubble-background: var(--pattern-accent-base);\n  --system-bubble-color: var(--pattern-accent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Messages__container-f38653`
};
module.exports = ___CSS_LOADER_EXPORT___;
